import { SpecialRoomOffersCardsCarousel } from "../../components/special-room-offers-cards";  
import { CollectionListDropDown } from "../../controls/collectionListDropdown"
import { EditionCardsCarousel, updateEditionCardLinkUrls } from "../../components/upcoming-editions";
import { initUpcomingEditionsFilter } from "../../components/upcoming-editions-filter";
import { ActivityCardsCarousel } from "../../components/activity-cards";
import { TestimonialCardsCarousel, initTestimonialCards } from "../../components/testimonial-cards";

document.addEventListener('DOMContentLoaded', function() {
  // Update edition card links
  updateEditionCardLinkUrls();

  // Initialize the upcoming editions filter
  initUpcomingEditionsFilter();

  // Initialize the testimonial cards
  initTestimonialCards();
});

// Initialize the Location Filter Dropdown in the Hero Section
CollectionListDropDown.init({ selector: "#destination-dropdown", onChange: (selectedItem) => {
	const selectedValue = selectedItem.getAttribute("data-value") || selectedItem.textContent.trim(); 
  const linkElement = document.querySelector("#find-workation-button");
  const baseUrl = linkElement.getAttribute("href").split("?")[0]; // Remove existing query params

  // Update the link's href with the new query parameter
  linkElement.setAttribute("href", `${baseUrl}?location=${encodeURIComponent(selectedValue)}`);
}});

// Initialize the carousel
SpecialRoomOffersCardsCarousel.init({
  swiper: '#special-room-offers-section .swiper',
  swiperWrapper: '#special-room-offers-section .swiper-wrapper',  
  pagination: '#special-room-offers-section .swiper-pagination',
});

// Initialize the carousel
EditionCardsCarousel.init({
  refContainer: "#edition-cards-swiper-ref-container", // this is needed for calculating the left offset
  swiper: '#edition-cards-section .swiper',
  swiperWrapper: '#edition-cards-section .swiper-wrapper',  
  prevButton: '#edition-cards-swiper-prev-btn',
  nextButton: '#edition-cards-swiper-next-btn'
});

// Initialize the carousel
ActivityCardsCarousel.init({
  refContainer: "#activity-cards-swiper-ref-container", // this is needed for calculating the left offset
  swiper: '#activity-cards-section .swiper',
  swiperWrapper: '#activity-cards-section .swiper-wrapper',  
  prevButton: '#activity-cards-swiper-prev-btn',
  nextButton: '#activity-cards-swiper-next-btn'
});

TestimonialCardsCarousel.initSwiper("#testimonial-cards-section .swiper");
